<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="solid" (click)="cancel()">
        <ion-icon slot="start" name="close-circle-outline"></ion-icon>
        {{ 'General.Cancel' | translate }}
      </ion-button>
    </ion-buttons>
    <ion-title>{{ title | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="false">
  <account-add-existing-card-form (onSubmit)="onFormSubmitted($event)"></account-add-existing-card-form>
</ion-content>